import { Provider, importProvidersFrom } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';

import StorePersistEffects from './store-persist.effects';

export const provideRootStateStorage = (): Provider => [importProvidersFrom(EffectsModule.forFeature([StorePersistEffects]))];
